// eslint-disable-next-line no-unused-vars
import React, {
    useState,
    useEffect,
    Fragment,
    memo
} from "react";
import "./navbar.scss";
import PropTypes from "prop-types";
import Asset from "./Asset";
import Contacts from "./Contacts";
import Vendors from "./Vendors";
import Accounting from "./Accounting";
import Contracts from "./Contracts";
import Orders from "./Orders";
import Reports from "./Reports";
import Settings from "./Settings";
import ControlPanel from "./ControlPanel";
import { Nav, NavDropdown, Navbar } from "react-bootstrap";
import { CarBuilding } from "../Icon";
import { connect } from "react-redux";
import {
    hasRole,
    CanI
} from "@redux-action/permissions/permissions";
import { getGroupModuleName } from "@redux-action/groups/groups";
import { handleResponse } from "@redux-action/response";
import { handleError } from "@redux-action/error";

/** @jsx jsx */
import { jsx, css, useTheme } from '@emotion/react';

const initialState = {
    super_user: false,
    contacts_view: false,
    vendors_view: false,
    vendor_bills_view: false,
    invoices_view: false,
    groups_view: false,
    contracts_view: false,
    orders_view: false,
    order_line_items_view: false,
    reports_view: false,
    properties_view: false,
    automobiles_view: false
};

const NavbarComp = ({
    CanI,
    hasRole,
    NAME,
    CLIENT,
    COMPONENT,
    handleResponse,
    handleError,
    getGroupModuleName,
    group_module_name
}) => {

    const theme = useTheme();

    const styles = css`

    z-index: 1052;
    position: sticky;
    .navbar-nav {
        .nav-item {
            border: 1px solid transparent;
            border-radius: 0.25em;
            &:hover,
            &:focus,
            &:focus-visible,
            &.show {
                border: 1px solid ${theme.colors.light};
                .nav-link {
                   color: ${theme.colors.light};
                }

                .list-group {
                    .list-group-item > .dropdown-item {
                        border: 1px solid transparent;
                        &:hover,
                        &:focus,
                        &:focus-visible {
                            border: 1px solid ${theme.colors.gray};
                        }
                    }
                }


                .dropdown-menu.show {
                    .card-header {
                        button {
                            border: 1px solid transparent;

                            &:hover,
                            &:focus,
                            &:focus-visible {
                                border: 1px solid ${theme.colors.gray};
                            }
                        }
                    }
                    .collapse.show {
                        .dropdown-item {
                            border: 1px solid transparent;

                            &:hover,
                            &:focus,
                            &:focus-visible {
                                border: 1px solid ${theme.colors.gray};
                            }
                        }
                    }
                }
            }
        }
    }
`;

    const [state, setState] = useState(initialState);
    const initComponent = async() => {
        await getGroupModuleName("group");
    };

    useEffect(() => {
        initComponent();
        async function initPermissions() {
            if (!COMPONENT) {
                return null;
            }

            setState({
                ...state,
                super_user: await hasRole(1),
                contacts_view: await CanI("contacts_view"),
                properties_view: await CanI("properties_view"),
                automobiles_view: await CanI("automobiles_view"),
                vendors_view: await CanI("vendors_view"),
                vendor_bills_view: await CanI("vendor_bills_view"),
                invoices_view: await CanI("invoices_view"),
                groups_view: await CanI("groups_view"),
                contracts_view: await CanI("contracts_view"),
                orders_view: await CanI("orders_view"),
                order_line_items_view: await CanI("order_line_items_view"),
                reports_view: await CanI("reports_view")
            });
            return true;
        }
        initPermissions()
            .then(() => console.debug("[NAVBAR INITIATED]"))
            .catch(() => console.debug("[NAVBAR INITIATE FAILED]"));
        return () => cleanUp();
    }, [group_module_name]);

    const cleanUp = () => {
        setState(initialState);
    };

    if (!COMPONENT) {
        return null;
    }
    const {
        super_user,
        contacts_view,
        vendors_view,
        vendor_bills_view,
        invoices_view,
        groups_view,
        contracts_view,
        orders_view,
        order_line_items_view,
        reports_view,
        properties_view,
        automobiles_view
    } = state;

    const getTitle = () => {
        if (CLIENT !== 'REALLOOK') {
            return NAME;
        }
        return (
            <span className="nav-reallook">
                <img src="/images/reallook-logo.png" alt="Real Look"/> REAL LOOK TRACK
            </span>
        );
    };

    return (
        <div css={styles}>
            <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
                <Navbar.Brand>{getTitle()}</Navbar.Brand>
                <Navbar.Toggle aria-controls="track-navbar-nav" />
                <Navbar.Collapse id="track-navbar-nav">
                    <Nav className="ml-auto">
                        {/* ASSET DROPDOWNS */}
                        {properties_view || automobiles_view ? (
                            <NavDropdown
                                alignRight
                                title={
                                    <Fragment>
                                        <CarBuilding
                                            width={20}
                                            height={25}
                                            className="mb-1"
                                        />{" "}
                                        Assets
                                    </Fragment>
                                }
                                active={
                                    COMPONENT === "properties" ||
                                    COMPONENT === "automobiles" ||
                                    COMPONENT === "tangibles" ||
                                    COMPONENT === "intangibles"
                                }
                                id="properties-dropdown"
                            >
                                <Asset
                                    CanI={CanI}
                                    handleResponse={handleResponse}
                                    handleError={handleError}
                                />
                            </NavDropdown>
                        ) : null}
                        {/* CONTACT DROPDOWNS */}
                        {contacts_view && (
                            <NavDropdown
                                alignRight
                                disabled={!contacts_view}
                                title={
                                    <Fragment>
                                        <i className="fa fa-user" /> Contacts
                                    </Fragment>
                                }
                                active={COMPONENT === "contacts"}
                                id="contacts-dropdown"
                            >
                                <Contacts CanI={CanI} />
                            </NavDropdown>
                        )}
                        {/* VENDORS DROPDOWNS */}
                        {vendors_view && (
                            <NavDropdown
                                alignRight
                                title={
                                    <Fragment>
                                        <i className="fa fa-shopping-cart" />{" "}
                                        Vendors
                                    </Fragment>
                                }
                                active={COMPONENT === "vendors"}
                                id="vendors-dropdown"
                            >
                                <Vendors
                                    CanI={CanI}
                                    handleResponse={handleResponse}
                                    handleError={handleError}
                                />
                            </NavDropdown>
                        )}

                        {/* ACCOUNTING DROPDOWNS */}
                        {vendor_bills_view || invoices_view ? (
                            <NavDropdown
                                alignRight
                                title={
                                    <Fragment>
                                        <i className="fa fa-dollar-sign" />{" "}
                                        Accounting
                                    </Fragment>
                                }
                                active={
                                    COMPONENT === "vendors_bills" ||
                                    COMPONENT === "invoices"
                                }
                                id="accounting-dropdown"
                            >
                                <Accounting CanI={CanI} />
                            </NavDropdown>
                        ) : null}
                        {/* CONTRACTS DROPDOWNS */}
                        {groups_view || contracts_view ? (
                            <NavDropdown
                                alignRight
                                title={
                                    <Fragment>
                                        <i className="fas fa-clipboard-list" />{" "}
                                        Contracts
                                    </Fragment>
                                }
                                active={
                                    COMPONENT === "groups" ||
                                    COMPONENT === "contracts"
                                }
                            >
                                <Contracts
                                    CanI={CanI}
                                    NAV_GROUPS_TEXT={group_module_name}
                                    super_user={super_user}
                                />
                            </NavDropdown>
                        ) : null}
                        {/* ORDERS DROPDOWNS */}
                        {orders_view || order_line_items_view ? (
                            <NavDropdown
                                alignRight
                                title={
                                    <Fragment>
                                        <i className="fas fa-hand-pointer" />{" "}
                                        Orders
                                    </Fragment>
                                }
                                id="orders-dropdown"
                                active={
                                    COMPONENT === "orders" ||
                                    COMPONENT === "order_line_items"
                                }
                            >
                                <Orders CanI={CanI} />
                            </NavDropdown>
                        ) : null}
                        {/* REPORTS DROPDOWNS */}
                        {reports_view && (
                            <NavDropdown
                                alignRight
                                title={
                                    <Fragment>
                                        <i className="fa fa-download" /> Reports
                                    </Fragment>
                                }
                                active={COMPONENT === "reports"}
                            >
                                <Reports CanI={CanI} />
                            </NavDropdown>
                        )}

                        {/* SETTINGS DROPDOWNS */}
                        <NavDropdown
                            alignRight
                            title={
                                <Fragment>
                                    <i className="fa fa-cogs" /> Settings
                                </Fragment>
                            }
                            active={COMPONENT === "account"}
                        >
                            <Settings CanI={CanI} />
                        </NavDropdown>

                        {/* CONTROL DROPDOWNS */}
                        <ControlPanel
                            CanI={CanI}
                            hasRole={hasRole}
                            COMPONENT={COMPONENT}
                        />
                    </Nav>
                    {/* <Form inline>
                    <FormControl
                        type="text"
                        placeholder="Search"
                        className="mr-sm-2"
                    />
                    <Button variant="outline-success">Search</Button>
                </Form> */}
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
};
NavbarComp.propTypes = {
    CanI: PropTypes.func,
    hasRole: PropTypes.func,
    APP: PropTypes.object,
    COMPONENT: PropTypes.string,
    handleResponse: PropTypes.func,
    handleError: PropTypes.func,
    getGroupModuleName: PropTypes.func
};

const mapStateToProps = state => ({
    NAV_GROUPS_TEXT: state.MISC.APP.NAV_GROUPS_TEXT,
    NAME: state.MISC.APP.NAME,
    CLIENT: state.MISC.APP.CLIENT,
    group_module_name: state.groups.group_module_name
    // COMPONENT: state.MISC.APP.ROUTE.component
});
export default connect(mapStateToProps, {
    hasRole,
    CanI,
    getGroupModuleName,
    handleError,
    handleResponse
})(memo(NavbarComp));
